import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { Store } from '@ngrx/store';
import { resetEnterprises } from 'src/store/enterprises/enterprises.actions';
import { resetPartnerEnterprise } from 'src/store/partner-enterprise/partner-enterprise.actions';
import {
  resetPermissions,
  resetSettings,
  resetUser,
} from 'src/store/user/user.actions';

import { Utility } from 'src/services/utility.service';

export const AuthenticationGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean | UrlTree> => {
  const store = inject(Store);

  Utility.removeStore('token');

  store.dispatch(resetUser());
  store.dispatch(resetSettings());
  store.dispatch(resetPermissions());

  store.dispatch(resetEnterprises());
  store.dispatch(resetPartnerEnterprise());

  return true;
};
